module.exports = {"TXTCLI_Currency":{"id":"TXTCLI_Currency","defaultMessage":"Währung","track":"Currency"}}